const MULTIPLE_CHART = 'MULTIPLE_CHAT';
const SINGLE_CHART = 'SINGLE_CHART';

export {
  SINGLE_CHART,
  MULTIPLE_CHART,
};
